import React from 'react';
import logo from '../../assets/solana.png';
import './partners.css';

const Partners = () => {
  return (
    <div id='partners'>
    <div class="py-16 bg-grey">
        <div class="container m-auto px-6 space-y-8 md:px-12 lg:px-56">
            <div class="m-auto text-center lg:w-7/12">
                <h2 class="text-5xl text-gray-700 font-bold md:text-4xl gradient__text">Our Partners</h2>
            </div>
            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4">
                <div class="p-4">
                    <img src="https://tailus.io/sources/blocks/company-site/preview/images/clients/airbnb.svg" class="" alt=""/>
                </div>
                <div class="p-4">
                    <img src="https://tailus.io/sources/blocks/company-site/preview/images/clients/client-8.png" class="w-32 " alt=""/>
                </div>
                <div class="p-4">
                    <img src="https://tailus.io/sources/blocks/company-site/preview/images/clients/client-3.png" class="w-32 " alt=""/>
                </div>
                <div class="p-4">
                    <img src="https://tailus.io/sources/blocks/company-site/preview/images/clients/client-1.png" class="w-32 " alt=""/>
                </div>
                <div class="p-4">
                    <img src="https://tailus.io/sources/blocks/company-site/preview/images/clients/tailus.svg" class="w-32" alt=""/>
                </div>
                <div class="p-4">
                    <img src="https://tailus.io/sources/blocks/company-site/preview/images/clients/microsoft.svg" class="w-32" alt=""/>
                </div>
                <div class="p-4">
                    <img src="https://tailus.io/sources/blocks/company-site/preview/images/clients/coty.svg" class="w-20" alt=""/>
                </div>
                <div class="p-4">
                    <img src="https://tailus.io/sources/blocks/company-site/preview/images/clients/client-4.png" class="w-24" alt=""/>
                </div>
            </div>
        </div>
    </div>
    <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
  </div>
  )
}

export default Partners